import React, { Fragment } from 'react'

const Select = ({item, register, errors}) => {
    return (
        <Fragment>
            <div className="flex flex-col col-span-6 max-[573px]:col-span-12 gap-2">
                <label className="text-[12px] font-medium">{item?.label}</label>
                <div className='flex flex-col gap-1'>
                    <select
                    disabled={item?.disabled}
                    name={item.name}
                    type={item?.type}
                    {...register(item.name)}
                    placeholder={item?.placeholder}
                    className="bg-white outline-none border h-[42px] border-gray-200 pl-4 rounded-lg text-[12px] font-medium pr-3"
                    bordered={true}
                    >
                        <option value="">Select {item?.label}</option>
                        {
                            item?.options?.map((opt, index) =>(
                                <option key={index} value={opt.id}>{opt?.name}</option>
                            ))
                        }
                    </select>
                    <div className='text-[red] italic text-[11px]'>{errors[item?.name]?.message}</div>
                </div>
            </div>
        </Fragment>
    )
}

export default Select